import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"close\"><title>close</title><g id=\"close__visibility\"><g id=\"close_Layer_8-2\" data-name=\"Layer 8\"><path d=\"M15.0962,14.3891,11.2071,10.5l3.8891-3.8891a.5.5,0,0,0-.7071-.7071L10.5,9.7929,6.6109,5.9038a.5.5,0,0,0-.7071.7071L9.7929,10.5,5.9038,14.3891a.5.5,0,0,0,.7071.7071L10.5,11.2071l3.8891,3.8891a.5.5,0,0,0,.7071-.7071Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = srjS
// module chunks = 4